import p from './copy';

export * from './copy';
export default p;
